<template>
  <div v-if="isVisible" class="column-filter">
    <template v-if="type==='range' && hasValidRange">
      <span>{{ $t('table_select_range') }}</span>
      <div class="range-slider">
        <VueSlider
          v-model="internalValue"
          :min="rangeMin"
          :max="rangeMax"
          :height="3"
          :min-range="0"
          :marks="objectMarks"
          :adsorb="true"
          :tooltip-formatter="val => formatData(val)"
          :style="{ padding: '0'}"
          :process-style="{ backgroundColor: 'black' }"
          :tooltip-style="{ backgroundColor: 'black', borderColor: 'black' }"
          :dot-style="{ backgroundColor: 'black', borderColor: 'black', boxShadow: '0.5px 0.5px 2px 1px rgb(0 0 0 / 32%)' }"
        />
        <div v-if="type==='range' && isMobile" class="mobile-input-container">
          <input
            v-model="internalMin"
            type="number"
            :min="rangeMin"
            :max="rangeMax"
          >
          <input
            v-model="internalMax"
            type="number"
            :min="rangeMin"
            :max="rangeMax"
          >
        </div>
      </div>
    </template>
    <template v-else-if="type==='string'">
      <div class="input-wrapper">
        <input v-model="internalValue">
        <div class="search-button-icon" />
      </div>
    </template>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { maskValue, flatNumberFormat } from '@/utils/formatUtils.js'

export default {
  components: { VueSlider },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: ['value', 'fullRange', 'type', 'dataCard'],
  data() {
    return {
      formatData: v => {
        //if por si estamos en una microdades (que haya consistencia con el format de la tabla)
        return this.dataCard?.mask ? maskValue(v, this.dataCard) : flatNumberFormat(v)
      },
    }
  },
  computed: {
    rangeMin() {
      return this.fullRange ? Number(this.fullRange[0]) : null
    },
    rangeMax() {
      return this.fullRange ? Number(this.fullRange[1]) : null
    },
    hasValidRange() {
      return Number.isFinite(this.rangeMin) && Number.isFinite(this.rangeMax) && this.rangeMin !== this.rangeMax
    },
    isVisible() {
      return (this.type === 'range' && this.hasValidRange) || this.type === 'string'
    },
    objectMarks() {
      if (this.hasValidRange) {
        let minNumber = this.rangeMin
        let maxNumber = this.rangeMax
        return {
          [minNumber]: {
            label: this.formatData(minNumber),
            labelStyle: {
              transform: 'translateX(0)',
            },
          },
          [maxNumber]: {
            label: this.formatData(maxNumber),
            labelStyle: {
              transform: 'translateX(-100%)',
            },
          },
        }
      } else return false
    },
    // type() {
    //   return 'range'
    // },
    defaultValue() {
      return this.type === 'range' && this.hasValidRange ? [this.rangeMin, this.rangeMax] : ''
    },
    internalValue: {
      get() {
        return this.value !== null && this.value !== undefined ? this.value : this.defaultValue
      },
      set(value) {
        this.$emit('change', value)
      },
    },
    internalMin: {
      get() {
        return this.internalValue[0]
      },
      set(min) {
        this.$emit('change', [+min, this.internalValue[1]])
      },
    },
    internalMax: {
      get() {
        return this.internalValue[1]
      },
      set(max) {
        this.$emit('change', [this.internalValue[0], +max])
      },
    },
  },
  methods: {
    /**
     * Sets the interal values with given range change information
     * @public This is a public method
     */
    rangeChange(min, max) {
      this.internalMin = min
      this.internalMax = max
    },
  },
  // watch: {
  //   internalValue: {
  //     handler() {
  //       this.$emit('change', this.internalValue)
  //     },
  //     deep: true,
  //   },
  // },
}
</script>

<style lang="stylus" scoped>
.column-filter
  display: flex
  flex-direction: column
  padding: vw(5px)
  background: white
  gap: vw(10px)

  .input-wrapper
    position: relative
    display: flex
    align-items: center

    input
      m-font-size(16, 20)
      padding: vw(5px) 0 vw(5px) vw(30px)
      width: 100%
      border: none
      border-radius: 5px
      background-color: $bcn-grey

    .search-button-icon
      position: absolute
      margin-left: vw(5px)
      m-icon("search-black", 22)

  .range-slider
    padding: vw(10px) vw(10px) 0

    .mobile-input-container
      display: flex
      justify-content: space-between
      margin-top: vw(40px)
      width: 100%

    .vue-slider
      margin-bottom: vw(15px)

  .range-pair
    display: flex

    .range-min,
    .range-max
      width: 50%
</style>
